import script from "./DownloadChristmas.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadChristmas.vue?vue&type=script&setup=true&lang=js"

import "./DownloadChristmas.vue?vue&type=style&index=0&id=70ccff7d&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70ccff7d"]])

export default __exports__